<template>
  <v-app>
    <v-content>
      <v-responsive class="parent-height" color="grey lighten-2">
        <nav-bar></nav-bar>
        <notifications position="top center" width="40%">
          <template slot="body" slot-scope="props">
            <v-container ma-0 pa-0>
              <v-layout row wrap>
                <v-flex
                  xs12
                  :class="['notification notifications-style', props.item.type]"
                  ma-1
                  pa-2
                >
                  <v-container ma-0 pa-0>
                    <v-layout row wrap>
                      <v-flex xs11>
                        <div class="notification-title">
                          {{ props.item.title }}
                        </div>
                      </v-flex>

                      <v-flex xs1>
                        <v-btn slot="activator" @click="props.close" icon small>
                          <img src="static/icons/close_white.png" width="22" />
                        </v-btn>
                      </v-flex>

                      <v-flex xs12>
                        <div class="notification-content">
                          {{ props.item.text }}
                        </div>
                      </v-flex>
                    </v-layout>
                  </v-container>
                </v-flex>
              </v-layout>
            </v-container>
          </template>
        </notifications>

        <router-view />
      </v-responsive>
    </v-content>
  </v-app>
</template>

<script>
import getDomainAlias from './assets/js/domain.js'

export default {
  created() {
    //link from WordPress optionally selects one of the exclusive lenders. store this temporarily
    //until we create an application and set it on the app
    let exclusiveLender = this.$cookie.get('tdc_provider')
    if (!exclusiveLender) {
      exclusiveLender = this.$route.query.xl
    }
    if (exclusiveLender) {
       //handle any external to internal (bankid) mappings
      if (exclusiveLender == 'gafh') {
        exclusiveLender = 'gafco';
      }
    }
    this.$store.commit('setSelectedExclusiveLender', exclusiveLender)

    let programDomain = getDomainAlias()

    //get the program for the programDomain and load it
    this.$store.commit('setProgramsFetched', false)
    axios
      .get('api/v1/pub/program/domain/'+programDomain)
      .then(response => {
        var domainFound = response.data

        if (domainFound) {
            document.getElementById('favicon').href = '/static/' + domainFound.domain + '/favicon.ico'
            this.$store.commit('setProgram', domainFound)
            this.$store.commit('setProgramsFetched', true)
            document.title = domainFound.name + ' - Enrollment Portal'
        }
      })
      .catch(error => {
        this.notifyAxiosError(
          error,
          'There was an error fetching programs. Has your dealer program been set up?'
        )
      })
  }
}
</script>



// WEBPACK FOOTER //
// src/App.vue